import React from 'react'

const OrderAckTAC = () => {
  return (
    <div
      style={{
        padding: '6rem 10% 6rem 10%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <object
        data="/mickey-order-acknowledgment-terms-and-conditions.pdf"
        type="application/pdf"
        width="100%"
        height="1000"
      ></object>
    </div>
  )
}

export default OrderAckTAC
